var freeshippingOutline = "https://shopfront-cdn.tekoapis.com/static/cedacbcaec1a1651.svg";

export { freeshippingOutline as default };
